module.exports = __webpack_public_path__ + "static/media/tutorial2.cf3790a9.mp4";